<template>
<el-row :gutter="24">
  <el-col :span="24">
    <el-row :gutter="0">
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.company_name, message: `请输入正确的在职企业名称 (中文)`, trigger: 'blur' }
          ]"
          prop="personal_content.company_name"
        >
          <div class="form-item-label" solt="label">
            在职企业名称 (中文)
          </div>
          <el-input v-model.trim="onJobInfo.personal_content.company_name" :maxlength="80" placeholder="请填写，自动翻译为英文" @blur="handleAutoTranslate(onJobInfo.personal_content.company_name, 'company_name_en')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="2">
        <div class="translate-box">
          <div class="translate-img"></div>
        </div>
      </el-col>
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.company_name_en, message: `请输入正确的在职企业名称 (英文)`, trigger: 'blur' }
          ]"
          prop="personal_content.company_name_en"
        >
          <div class="form-item-label" solt="label">
            在职企业名称 (英文)
          </div>
          <el-input v-model.trim="onJobInfo.personal_content.company_name_en" :maxlength="300" placeholder=""></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="0">
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.job, message: `请输入正确的职务 (中文)`, trigger: 'blur' }
          ]"
          prop="personal_content.job"
        >
          <div class="form-item-label" solt="label">
            职务 (中文)
          </div>
          <el-input v-model.trim="onJobInfo.personal_content.job" :maxlength="30" placeholder="请填写，自动翻译为英文" @blur="handleAutoTranslate(onJobInfo.personal_content.job, 'job_en')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="2">
        <div class="translate-box">
          <div class="translate-img"></div>
        </div>
      </el-col>
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.job_en, message: `请输入正确的职务 (英文)`, trigger: 'blur' }
          ]"
          prop="personal_content.job_en"
        >
          <div class="form-item-label" solt="label">
            职务 (英文)
          </div>
          <el-input v-model.trim="onJobInfo.personal_content.job_en" :maxlength="300" placeholder=""></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.hiredate, message: `请输入正确的入职时间`, trigger: 'change' }
          ]"
          prop="personal_content.hiredate"
        >
          <div class="form-item-label" solt="label">
            入职时间
          </div>
          <el-date-picker
            :value="onJobInfo.personal_content.hiredate"
            type="month"
            placeholder="选择日期"
            @input="handleChangeDate($event, 'hiredate')"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.monthly_income, message: `请输入正确的月收入(RMB)`, trigger: 'blur' }
          ]"
          prop="personal_content.monthly_income"
        >
          <div class="form-item-label" solt="label">
            月收入(RMB)
          </div>
          <el-input
            v-model.trim="onJobInfo.personal_content.monthly_income"
            :maxlength="14"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="0">
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.purpose, message: `请输入正确的出行目的 (中文)`, trigger: 'blur' }
          ]"
          prop="personal_content.purpose"
        >
          <div class="form-item-label" solt="label">
            出行目的 (中文)
          </div>
          <el-input v-model.trim="onJobInfo.personal_content.purpose" :maxlength="30" placeholder="请填写，自动翻译为英文" @blur="handleAutoTranslate(onJobInfo.personal_content.purpose, 'purpose_en')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="2">
        <div class="translate-box">
          <div class="translate-img"></div>
        </div>
      </el-col>
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.purpose_en, message: `请输入正确的出行目的 (英文)`, trigger: 'blur' }
          ]"
          prop="personal_content.purpose_en"
        >
          <div class="form-item-label" solt="label">
            出行目的 (英文)
          </div>
          <el-input v-model.trim="onJobInfo.personal_content.purpose_en" :maxlength="300" placeholder=""></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.country_id, message: `请选择正确的申请签证国家`, trigger: 'blur' }
          ]"
          prop="personal_content.country_id"
        >
          <div class="form-item-label" solt="label">
            申请签证国家
          </div>
          <el-select v-model="onJobInfo.personal_content.country_id" @change="changeCountry" autocomplete="off" filterable placeholder="选择国家">
            <el-option v-for="item in visaCountry" :key="item.country_id" :label="`${item.country} / ${item.country_en}`" :value="item.country_id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.arrival_date, message: `请输入正确的抵达日期`, trigger: 'change' }
          ]"
          prop="personal_content.arrival_date"
        >
          <div class="form-item-label" solt="label">
            抵达日期
          </div>
          <el-date-picker
            :value="onJobInfo.personal_content.arrival_date"
            type="date"
            placeholder="选择日期"
            @input="handleChangeDate($event, 'arrival_date')"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.personal_content.return_date, message: `请输入正确的返程日期`, trigger: 'change' }
          ]"
          prop="personal_content.return_date"
        >
          <div class="form-item-label" solt="label">
            返程日期
          </div>
          <el-date-picker
            :value="onJobInfo.personal_content.return_date"
            type="date"
            placeholder="选择日期"
            @input="handleChangeDate($event, 'return_date')"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>

  </el-col>
</el-row>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import translateService from '../../../services/translate-service';

export default {
  props: {
    onJobInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    checkConfig: {
      type: Object,
    },
  },
  data() {
    return {
      visaCountry: [], // 签证国家
    };
  },

  created() {
    this.getSysConfig().then((data) => {
      this.visaCountry = data.onjob_country;
    });
  },

  methods: {
    ...mapActions('config/', ['getSysConfig']),
    // 翻译
    handleAutoTranslate(text, field) {
      if (!text) return;
      translateService.translateEn(text).then((translateText) => {
        this.$set(this.onJobInfo.personal_content, field, translateText);
      });
    },
    // 更改国家时，需要把国家中文和英文都更新一下
    changeCountry() {
      if (!this.onJobInfo.personal_content.country_id) return;
      const item = this.visaCountry.find(item => item.country_id === this.onJobInfo.personal_content.country_id);
      this.$set(this.onJobInfo.personal_content, 'country', item.country);
      this.$set(this.onJobInfo.personal_content, 'country_en', item.country_en);
    },
    handleChangeDate(date, field) {
      if (!date) {
        this.$set(this.onJobInfo.personal_content, field, '');
      } else {
        this.$set(this.onJobInfo.personal_content, field, moment(date).format('YYYY-MM-DD'));
      }
    },
  },
};
</script>

<style lang="less" scoped>


</style>



// WEBPACK FOOTER //
// src/pages/on-job/components/edit-form-personal.vue